<template>
  <div class="person_set-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="goBack" class="nav-wrap">
        <p class="title">手机和密码设置</p>
      </yioks-page-nav>
      <div class="main-wrap">
        <vue-scroll :ops="vuescrollOpt">
          <div class="form-wrap">
            <el-form
              :model="formData"
              :rules="settingFormRules"
              ref="mainForm"
              label-width="115px"
              size="medium"
              class="form-cont"
            >
              <el-form-item label="用户名" prop="username" v-if="formData.username">
                <el-input v-model.trim="formData.username" class="input-w260" placeholder="请输入用户名" disabled></el-input>
              </el-form-item>
              <el-form-item label="手机" prop="phoneNum" class="">
                <el-input
                  v-model.trim="formData.phoneNum"
                  disabled
                  class="input-w260 input-right-btn"
                  placeholder="请输入手机"
                ></el-input>
                <el-button type="primary" @click="ifPhoneDiaShow = true" class="form-item-btn">修改</el-button>
              </el-form-item>
              <el-form-item label="密码" prop="password" class="">
                <el-button type="primary" @click="ifPasswordDiaShow = true" class="form-item-btn">修改</el-button>
              </el-form-item>
              <el-form-item label="姓名" prop="name" class="" v-if="!isStudentRole(userInfo.member_type) && !['dataDisplay', 'instructorAssistant'].includes(userInfo.member_type)">
                <el-input v-model.trim="formData.name" class="input-w260" placeholder="请输入姓名" :disabled="userAvaible(['expireStudent', 'expFive', 'registration', 'registrationFive', 'student', 'stuFive','teacher','teaFive' ], userInfo.member_type)"></el-input>
              </el-form-item>
              <!--<el-form-item label="注册足协" prop="the_fa_name" class="" v-if="userInfo.member_type==='expireStudent'">-->
                <!--<el-input v-model.trim="formData.the_fa_name" class="input-w260" placeholder="请输入绑定足协" disabled ></el-input>-->
              <!--</el-form-item>-->
              <el-form-item label="性别" prop="sex" class="" v-if="!isStudentRole(userInfo.member_type) && !['dataDisplay', 'instructorAssistant'].includes(userInfo.member_type)">
                <el-radio-group v-model="formData.sex" :disabled="userAvaible(['expireStudent', 'expFive', 'registration', 'registrationFive', 'student', 'stuFive','teacher','teaFive'], userInfo.member_type)">
                  <el-radio label="Male">男</el-radio>
                  <el-radio label="Female">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="讲师等级" prop="rating" class="" v-if="ifShowTeacherRating">
                <!-- <el-input
                  v-model.trim="formData.rating"
                  disabled
                  class="input-w260"
                  placeholder="请输入讲师等级"sasqqqssssss
                ></el-input> -->
                <el-select v-model.trim="formData.rating" placeholder="请输入讲师等级" disabled class="input-w260">
                  <!-- <el-option v-for='(list) in ratingList' :label="list.key" :value="list.value" :key='list.value'></el-option> -->
                  <el-option v-for='(list) in taecherLevelSelect' :label="list.key" :value="list.value" :key='list.value'></el-option>
                </el-select>
              </el-form-item>
              <!-- 机构管理员不显示 大数据展示角色也不显示 -->
              <template v-if="['student', 'stuFive', 'system', 'expireStudent','expFive','teacher','teaFive','instructorAssistant'].includes(userInfo.member_type)">
                <el-form-item :label="( ['super', 'supFive', 'system', 'sysFive','viewer','viewFive','qualificationInquire'].includes(userInfo.member_type)) ? '证件号' : '用户名/证件号'" prop="idNum">
                  <el-input v-model.trim="formData.idNum"
                            class="input-w260"
                            placeholder="请输入证件号"
                            :disabled="idNumStatus"></el-input>
                </el-form-item>
              </template>
              <!-- 学员暂时不显示 -->
              <el-form-item label="籍贯"  class="inline-item-wrap" :class="(userInfo.member_type==='expireStudent' || userInfo.member_type==='expFive')? 'no_scroll':''" v-if="!isStudent(userInfo.member_type) && !['dataDisplay', 'instructorAssistant'].includes(userInfo.member_type)" >
                <el-form-item label-width="0px" prop="province" class="form-input-item">
                  <el-select v-model="formData.province" class="hide"></el-select>
                  <select
                    class="set-sel input-w200"
                    @change="provinceChange"
                    v-model="formData.province"
                    :style="{border: provinceSelErr === true ? selTestErrorBorder: (provinceSelErr === false ? selTestRightBorder : '')}"
                  >
                    <option value="">请选择省份</option>
                    <option
                      v-for="(province) in provinceList"
                      :key="province.id"
                      :value="province.id"
                    >{{province.text}}</option>
                  </select>
                </el-form-item>
                <el-form-item label-width="0px" prop="city" class="form-input-item">
                  <el-select v-model="formData.city" class="hide"></el-select>
                  <select
                    class="set-sel input-w200"
                    @change="cityChange"
                    v-model="formData.city"
                    :style="{border: citySelErr === true ? selTestErrorBorder: (citySelErr === false ? selTestRightBorder : '')}"
                  >
                    <option value="">请选择市</option>
                    <option v-for="(city) in cityList" :key="city.id" :value="city.id">{{city.text}}</option>
                  </select>
                </el-form-item>
              </el-form-item>
              <!-- 学员暂时不显示 -->
              <el-form-item label="地址" prop="address" v-if="!isStudent(userInfo.member_type) && !['dataDisplay', 'instructorAssistant'].includes(userInfo.member_type) " class="">
                <el-input v-model.trim="formData.address" class="input-w260" placeholder="请输入地址"></el-input>
              </el-form-item>
              <!-- 学员暂时不显示 -->
              <el-form-item label="上传照片" prop="cover" v-if="!isStudent(userInfo.member_type) && !['teacher', 'teaFive','instructorAssistant','dataDisplay'].includes(userInfo.member_type)" class="up-form-item">
                <div class="upfile-wrap">
                  <image-up
                    :lt-size="{msg: '上传图片大小不能超过10MB!',reg: 10}"
                    :lt-format="{msg: '仅支持jpg,jpeg,png,gif格式的图片',reg: /^.*\.(jpg|png|jpeg|gif)$/i }"
                    :imgval.sync="formData.cover"
                    :cover='showImg'
                    :default-img="DefaultImg"
                    :dt="'12vh'"
                    :dis_upload="!dis_upload"
                  ></image-up>
                  <p class="tip">支持jpg,jpeg,png,gif格式的图片</p>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <!-- v-if="userInfo.member_type !=='student' && userInfo.member_type !=='expireStudent'" -->
      <div class="footer-btn" slot="footer" v-if="!userAvaible(['student', 'stuFive', 'expireStudent', 'expFive','dataDisplay', 'instructorAssistant'], userInfo.member_type)">
        <div class="btns">
          <div class="btn save"
               @click="saveSetting('mainForm')">保存
          </div>
          <div class="btn cancel"
               @click="goBack">取消
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      @closed="phoneDiaClose"
      :visible.sync="ifPhoneDiaShow"
      :close-on-click-modal="false"
      top="13vh"
      width="500px"
      class="yi-dialog-root edit-phone-dia"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title">绑定手机号</span>
      </div>
      <div class="dialog-content">
        <el-form
          :model="formPhone"
          :rules="formPhoneRules"
          ref="phoneForm"
          label-width="115px"
          size="medium"
          class="phone-form"
        >
          <el-form-item label="新的手机号" prop="newPhoneNum">
            <el-input
              v-model="formPhone.newPhoneNum"
              class="input-fl"
              type="text"
              placeholder="请输入新的手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="verificationCode" class="">
            <el-row style="position: relative">
              <el-col :span="14">
                <el-input
                  v-model.trim="formPhone.verificationCode"
                  class="input-fl"
                  placeholder="请输入验证码"
                ></el-input>
              </el-col>
              <el-col :span="1"></el-col>
              <el-col :span="9">
                <el-row type="flex" justify="end">
                <el-button type="primary"
                           v-if="codeBtnFlag"
                           @click="sendCode"
                           class="btn-fr">发送验证码</el-button>
                  <el-button v-else
                             disabled
                             type="info">{{sec}}秒后重发</el-button>
                </el-row>

              </el-col>
              <el-tooltip  placement="right" effect="light">
                <div slot="content" class="no_code_method">
                  <p>解决办法</p>
                  <p>1: 通讯异常会造成短信发送延时或者丢失，请尝试重新获取短信验证码；</p>
                  <p>2: 查看垃圾短信，是否被短信过滤软件拦截；</p>
                  <p>3: 请确认手机号码是否正确，手机是否欠费；</p>
                  <p>4: 关机后重新启动手机，重新加载手机和基站的通信链路；</p>
                  <p>5: 联系电话客服；</p>
                </div>
                <div class="get_none_code"  >收不到验证码？</div>
              </el-tooltip>
            </el-row>
          </el-form-item>
        </el-form>
        <div class="footer-btn" slot="footer">
          <div class="btns">
            <div class="btn save"
                 @click="saveNewPhone('phoneForm')">保存
            </div>
            <div class="btn cancel"
                 @click="ifPhoneDiaShow = false">取消
            </div>
          </div>
        </div>
        <p class="footer-tip">温馨提示：修改成功后，请使用新的手机号登录</p>
      </div>
    </el-dialog>
    <el-dialog
      @closed="passwordDiaClose"
      :visible.sync="ifPasswordDiaShow"
      :close-on-click-modal="false"
      top="13vh"
      width="500px"
      class="yi-dialog-root"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title">修改密码</span>
      </div>
      <div class="dialog-content">
        <el-form
          :model="passwordForm"
          :rules="formPassRules"
          ref="passForm"
          label-width="115px"
          class="password-form"
        >
          <el-form-item label="原密码" prop="oldPass">
            <el-input type="password"  autocomplete="off" v-model="passwordForm.oldPass" placeholder="请输入原密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPass">
            <el-input type="password" v-model="passwordForm.newPass" autocomplete="off" placeholder="请输入8—16位字母和数字组合"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input type="password" v-model="passwordForm.checkPass" autocomplete="off" placeholder="请确认新密码"></el-input>
          </el-form-item>
        </el-form>
        <div class="footer-btn" slot="footer">
          <div class="btns">
            <el-button type="primary" :loading='repeatSubmit' @click="saveNewPass('passForm')">保存
            </el-button>
            <el-button type="danger" @click="ifPasswordDiaShow = false">取消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- hideTips接收两个参数：参数1控制弹窗显示隐藏，参数2标记是否点击确定按钮(点击：true) -->
    <yioks-tips :showTips="tipsFlag"
      :tips="'确定放弃修改并返回吗？'"
      @hideTips="hideTipsDialog"></yioks-tips>
  </div>
</template>

<script>
import { area_list } from "@/assets/js/region";
import { correctStatus } from "@/assets/js/apiStatus";
import { teacherAccount } from "@/assets/js/status";
import createScrollOpt from "@/assets/js/vuescrollOption";
import DefaultImg from '@/assets/images/person.png'
import { getPwdSalt } from "@/api/common/api";
import { hex_hmac_sha256 } from "@/assets/js/sha";
import {storageData} from "@/assets/js/storage";
import {
  getPersonSetInfo,
  postEditPersonSet,
  postPhoneCode,
  postPhoneNum,
  postPassword
} from "@/api/setting/person";
import {teacher_level} from "@/assets/js/select"
import commonFun from "@/assets/js/yioks";
import fiveMixins from '@/minix/fiveMixins';

const { mobile_phone, idCard_number } = commonFun;
const HOSTURL = process.env.VUE_APP_URL;

export default {
  name: "PersonSet",
  mixins: [fiveMixins],
  data() {
    const validateNumberId = (rule, value, callback) => {
      /*if (idCard_number(value)) {
        // 如果后台校验有问题
        if (this.errObj.idNumber.isErr) {
          callback(new Error(this.errObj.idNumber.msg));
        } else {
          callback();
        }
      } else callback(new Error("请输入有效的身份证号"));*/
      callback();
    };
    const validateProvince = (rule, value, callback) => {
      if (value !== "") {
        this.provinceSelErr = false;
        callback();
      } else {
        this.provinceSelErr = true;
        callback(new Error("请选择省份"));
      }
    };
    const validateCity = (rule, value, callback) => {
      if (value !== "") {
        this.citySelErr = false;
        callback();
      } else {
        this.citySelErr = true;
        callback(new Error("请选择市"));
      }
    };
    const settingFormRules = {
      // 不可编辑的项不校验了
      // phoneNum: [{required: true, message: "请填写用户名/手机", trigger: "blur"}],
      // rating: [{required: true, message: "请填写讲师等级", trigger: "blur"}],
      name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
      the_fa_name: [{ required: true, message: "请填写注册足协", trigger: "blur" }],
      sex: [{ required: true, message: "请选择学员性别", trigger: "change" }],
      idNum: [
        {
          required: false,
          validator: validateNumberId,
          trigger: "blur"
        }
      ],
      // province: [
      //   { required: false, validator: validateProvince, trigger: `change` }
      // ],
      // city: [{ required: false, validator: validateCity, trigger: `change` }]
    };
    const formPhoneRules = {
      newPhoneNum: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (mobile_phone(value)) {
              // 如果后台校验手机号有问题
              if (this.errObj.newPhone.isErr) {
                callback(new Error(this.errObj.newPhone.msg));
              } else {
                // 如果前端 input blur 再次触发校验时输入框相比上次后台校验为异常的手机号一致，则还显示上次的错误信息
                // if(value === this.flagNeWPhonePre) callback(new Error(this.errObj.newPhone.msg));
                // else callback();
                callback();
              }
            } else {
              callback(new Error("请输入有效的11位手机号"));
            }
          },
          trigger: "blur"
        }
      ],
      verificationCode: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (this.$yioks.code(value)) {
              callback();
            } else {
              callback(new Error("请输入6位验证码"));
            }
          },
          trigger: "blur"
        }
      ]
    };
    const formPassRules = {
      oldPass: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请输入原密码"));
            } else {
              // 如果后台校验有问题
              if (this.errObj.oldPass.isErr) {
                callback(new Error(this.errObj.oldPass.msg));
              } else {
                callback();
              }
            }
          },
          trigger: "blur"
        }
      ],
      newPass: [
        {
          required: true,
          validator: (rule, val, callback) => {
            if (this.$yioks.pwd(val)) {
              callback();
            } else {
              callback(new Error("8—16位字母（区分大小写）和数字组合"));
            }
          },
          trigger: "blur"
        }
      ],
      checkPass: [
        {
          required: true,
          validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请再次输入密码"));
            } else if (value !== this.passwordForm.newPass) {
              callback(new Error("两次输入密码不一致!"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }
      ]
    };
    return {
      DefaultImg,
      // ratingList: teacher_level,
      repeatSubmit: false,
      settingFormRules,
      formPhoneRules,
      formPassRules,
      vuescrollOpt: createScrollOpt(),
      ifPhoneDiaShow: false,
      ifPasswordDiaShow: false,
      tipsFlag: false,
      idNumStatus : true ,
      selTestErrorBorder: "1px solid #f56c6c",
      selTestRightBorder: "1px solid #67c23a",
      // null 时表示为初始样式，即没有经过校验时候的样式
      provinceSelErr: null,
      citySelErr: null,
      countySelErr: null,
      provinceList: [],
      cityList: [],
      countyList: [],
      formData: {
        username: "",
        phoneNum: "",
        password: "",
        name: "",
        sex: "Male",
        rating: "",
        idNum: "",
        address: "",
        province: "",
        city: "",
        county: "",
        cover: "",
        the_fa_name:''
      },
      formPhone: {
        newPhoneNum: "",
        verificationCode: ""
      },
      passwordForm: {
        oldPass: "",
        newPass: "",
        checkPass: ""
      },
      // 标记后台对某些值的校验结果和校验错误信息;
      errObj: {
        newPhone: {
          msg: "",
          isErr: false
        },
        oldPass: {
          msg: "",
          isErr: false
        },
        idNumber: {
          msg: "",
          isErr: false
        }
      },
      // 标记上次后台校验结果为异常的手机号
      flagNeWPhonePre: "",
      // 当前用户id，会在请求中获取并改变🍔
      userId: null,
      // 标记用户进入页面时候的默认头像图片地址
      avatorUrl: null,
      // 保存回显的用户头像
      showImg: null,
      // 当前登录的用户的信息
      userInfo: this.$store.state.userInfo,
      codeBtnFlag: true,
      sec: 60,
      dis_upload:false,
    };
  },
  computed: {
    // 当前角色下是否显示讲师等级
    ifShowTeacherRating() {
      return ['teacher', 'teaFive'].indexOf((this.userInfo || {}).member_type) !== -1;
    }
  },
  created() {
    this.getProvinceList();
    this.getSetInfo();
  },
  methods: {
    saveSetting(formName) {
      this.$refs[formName].validate(valid => {
        const { formData } = this;
        if (valid) {
          postEditPersonSet({
            name: formData.name,
            id_number: formData.idNum,
            province_id: formData.province,
            city_id: formData.city,
            gender: formData.sex,
            address: formData.address,
            // 如果用户没有上传头像的话就传空
            image_url: formData.cover === this.avatorUrl ? "" : formData.cover
          })
            .then(({ data }) => {
              if (data.status === correctStatus) {
                const info = {
                  name: formData.name,
                  mobile_phone: formData.phoneNum,
                  profile_picture: data.result.profile_picture,
                };
                this.$store.commit("updateUserInfo", {
                  ...this.userInfo,
                  ...info
                });
                this.$message.success("修改成功");
                this.$router.push({ name: "Organization" });
              } else if(data.status === 415){
                // 后台校验身份证号有问题
                this.errObj.idNumber.msg = data.msg;
                this.errObj.idNumber.isErr = true;
                this.$refs[formName].validateField("idNum");
              } else {}
              this.errObj.idNumber.isErr = false;
            })
            .catch(error => {
              console.info(error);
            });
        } else {
          console.info("error submit!!");
          return false;
        }
      });
    },
    phoneDiaClose() {
      this.$refs["phoneForm"].resetFields();
    },
    passwordDiaClose() {
      this.$refs["passForm"].resetFields();
    },
    countdown() {
      this.codeBtnFlag = false;
      const timer = setInterval(() => {
        this.sec = this.sec - 1;
        if (this.sec == 0) {
          this.sec = 60;
          this.codeBtnFlag = true;
          clearInterval(timer);
        }
      }, 1000);
    },
    // 判断身份
    isShow(member_type){
      // let res=true;
      // switch(member_type){
      //   case 'stuFive' :
      //   case 'student' :
      //   case 'teaFive' :
      //   case 'teacher' :
      //   case 'expFive' :
      //   case 'expireStudent':res=false;break
      // }
      // return res
      if(member_type) {
        return ['stuFive', 'student', 'expireStudent', 'expFive'].includes(member_type)
      } else {
        return false
      }
      
    },
    // 发送验证码
    sendCode() {
      const num = this.formPhone.newPhoneNum;
      if (mobile_phone(num)) {
        postPhoneCode({ mobile_phone: num }).then(({ data }) => {
          if (data.status === correctStatus) {
            // console.log("验证码已发送，请注意查收。");
            this.$message.success("验证码发送成功");
            /* 倒计时 */
            this.countdown();
          } else {
            this.errObj.newPhone.msg = data.msg;
            this.errObj.newPhone.isErr = true;
            this.$refs["phoneForm"].validateField("newPhoneNum");
            // this.flagNeWPhonePre = num
            // console.info('code abnormal')
          }
          // 显示后台的检验结果之后，重置 this.errObj.newPhone.isErr ，让新绑定手机号的检验在普通的 blur 触发校验时不再显示之前后台的校验，就是之后点击发送验证码的时候才会显示后台的校验结果
          this.errObj.newPhone.isErr = false;
        });
      } else {
        // 输入内容不符合格式时，显示提示信息
        this.$refs["phoneForm"].validateField("newPhoneNum");
      }
    },
    // 保存新绑定的手机号
    saveNewPhone(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const { formPhone } = this;
          postPhoneNum({
            mobile_phone: formPhone.newPhoneNum,
            code: formPhone.verificationCode
          }).then(({ data }) => {
            if (data.status === correctStatus) {
              this.formData.phoneNum = formPhone.newPhoneNum;
              this.ifPhoneDiaShow = false;
            } else {
              this.$message.error(data.msg);
            }
          });
        } else {
          console.info("error submit!!");
          return false;
        }
      });
    },
    // 保存新密码
    saveNewPass(formName) {
      if(this.repeatSubmit){return;}
      this.repeatSubmit = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          const { passwordForm } = this;
          // 获取盐
          getPwdSalt({ user_id: this.userId })
            .then(({ data }) => {
              if (data.status === correctStatus) {
                const { regist_salt, salt_old } = data.result.data;

                const newPass = hex_hmac_sha256(
                  regist_salt,
                  passwordForm.newPass.toString()
                ).toUpperCase();
                const checkPass = hex_hmac_sha256(
                  regist_salt,
                  passwordForm.checkPass.toString()
                ).toUpperCase();
                const oldPass = hex_hmac_sha256(
                  salt_old,
                  passwordForm.oldPass.toString()
                ).toUpperCase();
                const editData = {
                  ...passwordForm,
                  oldPass,
                  newPass,
                  checkPass,
                  regist_salt
                };
                // 向后台发送修改密码的信息
                postPassword({
                  password: editData.oldPass,
                  new_password: editData.newPass,
                  affirm_password: editData.checkPass,
                  regist_salt: editData.regist_salt,
                })
                  .then(({ data }) => {
                    if (data.status === correctStatus) {
                      this.ifPasswordDiaShow = false;
                    } else {
                      this.errObj.oldPass.msg = data.msg;
                      this.errObj.oldPass.isErr = true;
                      this.$refs["passForm"].validateField("oldPass");
                    }
                    this.errObj.oldPass.isErr = false;
                    this.repeatSubmit = false;
                  })
                  .catch(err => {
                    this.repeatSubmit = false;
                    console.error(err);
                  });
              }
            })
            .catch(err => {
              this.repeatSubmit = false;
              console.error(err);
            });
        } else {
          this.repeatSubmit = false;
          console.info("error submit!!");
          return false;
        }
      });
    },
    // 获取个人信息
    getSetInfo() {
      getPersonSetInfo()
        .then(({ data }) => {
          if (data.status === correctStatus) {
            const { user } = data.result;
            this.userId = user.user_id;
            this.formData.phoneNum = user.mobile_phone || "";
            // this.formData.password = user.password
            this.formData.name = user.name;
            this.formData.the_fa_name = user.the_fa_name;
            this.formData.username = user.username || "";
            this.formData.sex = user.gender;
            this.formData.rating = this.isFive ? user.teacher_level_five : user.teacher_level;
            this.formData.idNum = user.id_number;
            this.formData.address = user.address;
            this.formData.province = String(user.province_id === 0 ? '' : user.province_id);
            this.idNumStatus = Boolean(user.id_number);
            // 这句必须放在为表单回显的city值赋值之前，因为 provinceChange 方法中会重置回显表单中的city值为空，所以这句下面需要重新为city赋值
            this.provinceChange();
            this.formData.city = String(user.city_id === 0 ?'':user.city_id);
            this.avatorUrl = user.profile_picture;
            if (this.userInfo.member_type==='registration') {
              this.dis_upload=user.profile_picture ? true :false;
            }
            this.showImg = this.avatorUrl && HOSTURL + this.avatorUrl;
            this.formData.cover = user.profile_picture;
          } else {
          }
        })
        .catch(err => {
          console.info("请求失败", err);
        });
    },
    // 获取省数据
    getProvinceList() {
      const vessel = [];
      for (const reg of area_list) {
        vessel.push({
          text: reg.regionName,
          id: reg.id
        });
      }
      this.provinceList = [...vessel];
    },
    cityChange() {
      this.formData.county = "";
      const vessel = [];
      if (this.curProvince !== undefined) {
        const curCity = this.curProvince.city.find(item => {
          return item.id === this.formData.city;
        });
        if (curCity !== undefined && curCity.county) {
          for (const county of curCity.county) {
            vessel.push({
              text: county.regionName,
              id: county.id
            });
          }
        }
      }
      this.countyList = [...vessel];
    },
    provinceChange() {
      const vessel = [];
      const curProvince = area_list.find(item => {
        return item.id === this.formData.province;
      });
      this.curProvince = curProvince;
      this.formData.city = "";
      this.cityChange();
      if (curProvince !== undefined) {
        for (const city of curProvince.city) {
          vessel.push({
            text: city.regionName,
            id: city.id
          });
        }
      }
      this.cityList = [...vessel];
    },
    countyChange() {},
    goBack() {
      this.tipsFlag = true;
    },
    hideTipsDialog(bool, sure) {
      this.tipsFlag = bool;
      if (sure) {
        this.$router.go(-1);
      } else {

      }
    },
    isStudent(userType) {
      if(userType) {
        const res = ['student', 'expireStudent', 'stuFive', 'expFive'].includes(userType)
        return res;
      } else {
        return false
      }
    },
  },
  components: {
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "image-up": () => import("@/components/UpImage/UpImage"),
    "yioks-tips": () => import("@/components/Tips/Dialog")
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/linDialog'

$page_main_height = 680px
.person_set-root
  zuxie-page-root()
  .el-form-item {
    margin-bottom: 40px;
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .no_scroll{
    margin-bottom 0
  }
  .input-w200
    width 200px
  .input-w260
    width 260px
  .input-w273
    width 273px
  .main-content-wrap
    color $color_white
    .nav-wrap
      margin-bottom 20px
      .title
        line-height 1
        font-size $font_size_big
      .nav-right
        color $color_err
        margin-right 12px
    .footer-btn
      text-align center
      .btns {
        display: flex;
        justify-content: center;
        color: $color_white;
        .btn {
          padding: 10px 25px;
          margin: 0 10px;
          border-radius: 4px;
          cursor: pointer;
          user-select: none;
        }
        .save {
          background-color: $color_suc;
        }
        .cancel {
          background-color: $color_err;
        }
      }
    .main-wrap
      display block
      width 100%
      height 560px
      padding 40px 0px 0px 50px
      position relative
      background-color $block_bg_color_base
      margin-bottom 15px
      .form-wrap
        display block
        width 100%
        padding-right 35px
        padding-left 20px
        height 510px
        .form-cont
          select
            outline none
          select[disabled]
            input-disabled()
          .inline-item-wrap
            .form-input-item
              float left
              margin-right 10px
            .form-item-btn
              float left
          .no_scroll
            margin-bottom 0
          .input-right-btn
            margin-right 10px
          .set-sel
            display block
            height 36px
            border 1px solid #dcdfe6
            border-radius 4px
            color #606266
          .up-form-item
            .upfile-wrap
              display block
              .tip
                display block
                font-size $font_size_base
                line-height 30px
        .hide
          display none
        .el-form-item__label
          color $color_white
          font-size 16px
        .el-radio
          color $color_white
        .el-input__inner, .el-textarea__inner
          // border-radius 0
        .el-input.is-disabled .el-input__icon
          color #666
        .el-form-item.is-required .el-form-item__label:before
          color inherit
        .el-input.is-disabled .el-input__inner
          input-disabled()
  .edit-phone-dia
    .get_none_code
      position: absolute;
      bottom: -30px;
      cursor: pointer;
      right: 14px;
      color: #606266;
    .btn-fr
      float right
    .input-fl
      float left
    .footer-btn
      padding 10px 0
      // margin-bottom 10px
    .footer-tip
      color $color_err
      font-size $font_size_medium
      text-align center
  .yi-dialog-root
    .btns {
      display: flex;
      justify-content: center;
      color: $color_white;
      .btn {
        padding: 10px 25px;
        margin: 0 10px;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;
      }
      .save {
        background-color: $color_suc;
      }
      .cancel {
        background-color: $color_err;
      }
    }
</style>

<style lang="stylus">
  .no_code_method
    width 400px
    p
      font-size 14px
      color #606266
      margin-bottom  7px
      &:first-child
        border-bottom 1px solid #606266
        font-size 15px
</style>

